import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <MediaSection />
        <FaqSection />
        <ContactSection />
        <TopicsSection />
        <CommentsSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <FeaturesSection />
        <AboutSection />
        <AppSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}